// | ------------------------------------------------------------------------
// | Imports
// | ------------------------------------------------------------------------

window.$ = window.jQuery = jQuery;

// | Vendors ----------------------------------------------------------------

// Bootstrap
import "@popperjs/core"; // Popper is required for dropdowns, popovers and tooltips.

// Bootstrap classes removed -  Button, Carousel, OffCanvas, Toast, Popover, Tooltip (remember to enable any styles if you re-enable any of these)
import { Alert, Collapse, Dropdown, Modal, ScrollSpy, Tab } from "bootstrap";

import LazyLoad from "vanilla-lazyload";
import { OverlayScrollbars } from "overlayscrollbars"; // Used on product filters

import Splide from "@splidejs/splide"; //? https://splidejs.com/
//import GLightbox from 'glightbox/dist/js/glightbox.js'; //? https://github.com/biati-digital/glightbox
import AOS from "aos"; //? https://github.com/michalsnik/aos

import validate from "jquery-validation";

//import { autocomplete } from '@algolia/autocomplete-js';
//import '@algolia/autocomplete-theme-classic';

import shave from "shave";

// | Template Components ----------------------------------------------------

// Cookies
// import './components/cookieConsent/cookieOptions'; // replaced by 3rd party script

// Navigation
import "./components/mainNavigation";
import "./components/dropdownOnHover";

// Header
import "./components/fixedHeader";

// Images
import "./components/imageLazyLoad";
import "./components/modernizr-webp";

// Forms
import "./components/quantityInputs";

// Shop Specific
import "./components/productFilters";
import "./components/productGallery";
//import "./components/productGrid";
import "./components/tableRowLinks";

//import "./components/ellipsis";
import "./components/webp";

// | Page Specific ----------------------------------------------------------

import "./components/homeCarousels";
import "./components/newsGallery";

// | ------------------------------------------------------------------------
// | Code
// | ------------------------------------------------------------------------

window.$ = window.jQuery = jQuery;

var stickyNav = document.querySelector(".sticky-nav");

if (stickyNav) {
  window.onscroll = function () {
    const el = document.querySelector(".sticky-nav");
    const observer = new IntersectionObserver(
      ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
      { threshold: [1] }
    );

    observer.observe(el);
  };
}

const prodViewBox = document.querySelector(".product-action-col");

if (prodViewBox) {
  function fixAddCart() {
    var scroll = window.pageYOffset;
    var headerHeight = parseInt(
      document.documentElement.style.getPropertyValue("--header-height")
    );
    var BoxOffsetTop = prodViewBox.offsetTop;
    var prodViewBoxOffsetTop = headerHeight + BoxOffsetTop + 16;

    if (scroll >= prodViewBoxOffsetTop) {
      document.querySelector(".product-action-col").classList.add("is-pinned");
    } else {
      document
        .querySelector(".product-action-col")
        .classList.remove("is-pinned");
    }
  }

  fixAddCart();

  window.addEventListener("scroll", fixAddCart, false);
}

function parallaxBlur() {
  var parallaxElement = document.querySelector(".parallax-bg");

  if (parallaxElement) {
    var elementHeight = parallaxElement.offsetHeight;

    var scrollPos = window.pageYOffset;
    var transformValue = scrollPos / 40;
    var opacityValue = 1 - scrollPos / 1000;
    var blurValue = Math.min(scrollPos / 100, 3);

    if (scrollPos < elementHeight) {
      Object.assign(parallaxElement.style, {
        transform: "translate3d(0," + transformValue + "%, 0)",
        opacity: "" + opacityValue + "",
        filter: "blur(" + blurValue + "px)",
      });
    }
  }
}

window.addEventListener("scroll", parallaxBlur, false);

window.addEventListener("load", (event) => {
  AOS.init(); // not sure why this doesn't work in an imported file...
});

// Lazy load images in menu
class ClassWatcher {
  constructor(
    targetNode,
    classToWatch,
    classAddedCallback,
    classRemovedCallback
  ) {
    this.targetNode = targetNode;
    this.classToWatch = classToWatch;
    this.classAddedCallback = classAddedCallback;
    this.classRemovedCallback = classRemovedCallback;
    this.observer = null;
    this.lastClassState = targetNode.classList.contains(this.classToWatch);

    this.init();
  }

  init() {
    this.observer = new MutationObserver(this.mutationCallback);
    this.observe();
  }

  observe() {
    this.observer.observe(this.targetNode, { attributes: true });
  }

  disconnect() {
    this.observer.disconnect();
  }

  mutationCallback = (mutationsList) => {
    for (let mutation of mutationsList) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        let currentClassState = mutation.target.classList.contains(
          this.classToWatch
        );
        if (this.lastClassState !== currentClassState) {
          this.lastClassState = currentClassState;
          if (currentClassState) {
            this.classAddedCallback();
          } else {
            this.classRemovedCallback();
          }
        }
      }
    }
  };
}

let myDropdown = document.getElementById("prodDropDown");

function workOnClassAdd() {
  var menuImageSrc = document.querySelectorAll(".nav-grid-row picture source");
  var menuImages = document.querySelectorAll(".nav-grid-row img");

  menuImageSrc.forEach((imgsrc) => {
    imgsrc.setAttribute("srcset", imgsrc.dataset.srcset);
  });

  menuImages.forEach((img) => {
    img.setAttribute("src", img.dataset.src);
  });
}

function workOnClassRemoval() {}

// watch for a specific class change
let classWatcher = new ClassWatcher(
  myDropdown,
  "show",
  workOnClassAdd,
  workOnClassRemoval
);

document.addEventListener("DOMContentLoaded", function () {
  shave(".ellipsis", 84, { character: "..." });

  var infoProdPage = document.getElementById("info-product-page");

  if (infoProdPage) {
    const scrollSpy = new ScrollSpy(infoProdPage, {
      target: "#infoProdNav",
    });
  }

  var homeLogoCarousel = document.querySelector(".home-logo-carousel");

  if (homeLogoCarousel) {
    new Splide(homeLogoCarousel, {
      type: "loop",
      gap: 16,
      perPage: 5,
      perMove: 1,
      cover: true,
      arrows: true,
      isNavigation: false,
      pagination: false,
      breakpoints: {
        320: {
          perPage: 1,
          arrows: true,
        },
        576: {
          perPage: 2,
          arrows: true,
        },
        992: {
          perPage: 3,
          arrows: true,
        },
        1200: {
          perPage: 4,
          arrows: true,
        },
      },
    }).mount();
  }

  var homeProdCarousels = document.getElementsByClassName("home-prod-carousel");

  if (homeProdCarousels) {
    for (var i = 0; i < homeProdCarousels.length; i++) {
      new Splide(homeProdCarousels[i], {
        type: "loop",
        gap: 16,
        perPage: 3,
        perMove: 1,
        cover: true,
        isNavigation: true,
        pagination: false,
        breakpoints: {
          576: {
            perPage: 1,
          },
          1200: {
            perPage: 2,
          },
        },
      }).mount();
    }
  }

  var homeBoostCarousels = document.getElementsByClassName(
    "home-boost-carousel"
  );

  if (homeBoostCarousels) {
    for (var i = 0; i < homeBoostCarousels.length; i++) {
      new Splide(homeBoostCarousels[i], {
        type: "loop",
        gap: 16,
        perPage: 2,
        perMove: 1,
        cover: true,
        isNavigation: true,
        pagination: false,
        arrows: false,
        breakpoints: {
          576: {
            perPage: 1,
            arrows: true,
          },
          1200: {
            perPage: 2,
            arrows: false,
          },
        },
      }).mount();
    }
  }

  $(document).ready(function () {
    $(".validate").validate();
  });

  var checkMobileCollapse = function () {
    var mobileCollapses = document.querySelectorAll(".mobile-collapse");

    mobileCollapses.forEach(function (e) {
      const mediaQuery = window.matchMedia("(min-width: 768px)");
      var mobileCollapse = Collapse.getOrCreateInstance(e);

      if (mediaQuery.matches) {
        mobileCollapse.show();
      } else {
        mobileCollapse.hide();
      }
    });
  };

  window.addEventListener("load", checkMobileCollapse, false);
  window.addEventListener("resize", checkMobileCollapse, false);

  document.querySelectorAll("#productsTab a").forEach(function (navItem) {
    // Open tabs on hover
    var tabTrigger = new Tab(navItem);
    navItem.addEventListener("mouseenter", function () {
      tabTrigger.show();
    });

    // Click takes you to the relevant page
    navItem.addEventListener("click", function () {
      var navUrl = navItem.getAttribute("href");
      console.log(navUrl);
      window.location.href = navUrl;
    });
  });
});

var actionBar = document.querySelector(".action-bar");

if (actionBar) {
  var actionBarHeight = function () {
    var actionBar = document.querySelector(".action-bar");

    if (actionBar) {
      var actionBarHeight = actionBar.offsetHeight;
      document.documentElement.style.setProperty(
        "--action-bar-height",
        actionBarHeight + "px"
      );
    } else {
      document.documentElement.style.setProperty(
        "--action-bar-height",
        0 + "px"
      );
    }
  };

  // Run on scroll/load/resize
  window.addEventListener("scroll", actionBarHeight, false);
  window.addEventListener("load", actionBarHeight, false);
  window.addEventListener("resize", actionBarHeight, false);
}

const scrollLinks = document.querySelectorAll(".scroll-link");

for (const scrollLink of scrollLinks) {
  scrollLink.addEventListener("click", scrollLinkHandler);
}

function scrollLinkHandler(e) {
  e.preventDefault();

  const href = this.getAttribute("href");

  // get the correct offset
  const getOffsetTop = (element) => {
    let offsetTop = 0;
    while (element) {
      offsetTop += element.offsetTop;
      element = element.offsetParent;
    }
    return offsetTop;
  };

  // find the target element
  const scrollTarget = document.querySelector(href);

  // the elements offset value
  const offsetTop = getOffsetTop(scrollTarget);

  // current header height value
  const x = getComputedStyle(document.documentElement).getPropertyValue(
    "--header-height"
  );

  // convert to integer
  const headerHeight = parseInt(x);

  // minus header height from the offset
  const totalOffset = offsetTop - headerHeight;

  if (window.matchMedia("(min-width: 768px)").matches) {
    // scroll to element minus the header height
    scroll({
      top: totalOffset,
      behavior: "smooth",
    });
  } else {
    // scroll to element
    scroll({
      top: totalOffset,
      behavior: "smooth",
    });
  }
}

// | ------------------------------------------------------------------------
// | Debugging
// | ------------------------------------------------------------------------

// import "./debugging/cls";
